import {
  CardsComponent,
  CardsComponentLoading,
} from '@/catalog-apps/components/component-library/CardsComponent.tsx/CardsComponent'
import { ChartComponent, ChartLoading } from '@/catalog-apps/components/component-library/ChartComponent'
import {
  ChatComponent,
  ChatComponentLoading,
} from '@/catalog-apps/components/component-library/ChatComponent/ChatComponent'
import {
  LiveChatComponent,
  LiveChatComponentLoading,
} from '@/catalog-apps/components/component-library/LiveChatComponent/LiveChatComponent'
import { DataTableComponent, DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { FormComponent, FormComponentLoading } from '@/catalog-apps/components/component-library/FormComponent'
import {
  QuickNavComponent,
  QuickNavLoading,
} from '@/catalog-apps/components/component-library/QuickNavComponent/QuickNavComponent'
import { StatementEditorComponent } from '@/catalog-apps/components/component-library/StatementEditorComponent'
import { TileFiltersProvider } from '@/catalog-apps/hooks/useTileFilters'
import clsx from 'clsx'
import { Suspense } from 'react'
import { ComponentSizing, TComponentConfig, TComponentType } from '../../types'
import { useAppPageState } from '../../useAppPageState'
import {
  DataFormComponent,
  DataFormComponentLoading,
} from '@/catalog-apps/components/component-library/DataFormComponent/DataFormComponent'
import { TabContainerComponent } from '@/catalog-apps/components/component-library/TabContainerComponent.tsx/TabContainerComponent'
import {
  MdTextComponent,
  MdTextComponentLoading,
} from '@/catalog-apps/components/component-library/MdTextComponent/MdTextComponent'
import {
  ChartSankeyComponent,
  ChartSankeyComponentLoading,
} from '@/catalog-apps/components/component-library/ChartSankey/ChartSankeyComponent'
import {
  TreeNavigatorComponent,
  TreeNavigatorComponentLoading,
} from '@/catalog-apps/components/component-library/TreeNavigator/TreeNavigatorComponent'
import { AnimatePresence, motion } from 'motion/react'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { PRESENCE_ANIMATION } from '@/const'
import {
  ChartRadialComponent,
  ChartRadialComponentLoading,
} from '@/catalog-apps/components/component-library/ChartRadial/ChartRadialComponent'
import {
  ChartBarComponent,
  ChartBarComponentLoading,
} from '@/catalog-apps/components/component-library/ChartBar/ChartBarComponent'
import {
  ChartScatterComponent,
  ChartScatterComponentLoading,
} from '@/catalog-apps/components/component-library/ChartScatter/ChartScatterComponent'
import {
  ChartHeatmapComponent,
  ChartHeatmapComponentLoading,
} from '@/catalog-apps/components/component-library/ChartHeatmap/ChartHeatmapComponent'
import {
  ChartPieComponent,
  ChartPieComponentLoading,
} from '@/catalog-apps/components/component-library/ChartPie/ChartPieComponent'
import { BuilderComponentSelector } from '../../../../../pages/Applications/AppPageBuilderPage/BuilderComponentSelector'
import { useIsPageBuilder } from '@/catalog-apps/hooks/useIsPageBuilder'
import {
  ChartRadarComponent,
  ChartRadarComponentLoading,
} from '@/catalog-apps/components/component-library/ChartRadar/ChartRadarComponent'
import {
  StepperComponent,
  StepperComponentLoading,
} from '@/catalog-apps/components/component-library/StepperComponent/StepperComponent'
import {
  ChartDumbbellComponent,
  ChartDumbbellComponentLoading,
} from '@/catalog-apps/components/component-library/ChartDumbbell/ChartDumbbellComponent'
import {
  DataTableV2Component,
  DataTableV2ComponentLoading,
} from '@/catalog-apps/components/component-library/DataTableV2/DataTableV2Component'
import {
  ChartLineComponent,
  ChartLineComponentLoading,
} from '@/catalog-apps/components/component-library/ChartLine/ChartLineComponent'
import {
  StatementEditorV2Component,
  StatementEditorV2ComponentLoading,
} from '@/catalog-apps/components/component-library/StatementEditorV2/StatementEditorV2Component'
import {
  useAiChatComponentContext,
  getAiChatComponentSelectionKey,
} from '@/catalog-apps/components/AppSupportMenuAiChat/useAiChatComponentContext'
import {
  findLatestComponentContextSnapshot,
  isComponentTypeContextSelectable,
} from '@/catalog-apps/components/AppSupportMenuAiChat/aiChatComponentSnapshot'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { Checkbox } from '@/components/shadcn/checkbox'
import { useIsFetching, useQueryClient } from '@tanstack/react-query'
import {
  FileManagerComponent,
  FileManagerComponentLoading,
} from '@/catalog-apps/components/component-library/FileManager/FileManagerComponent'
import {
  AgentChatComponent,
  AgentChatComponentLoading,
} from '@/catalog-apps/components/component-library/AgentChat/AgentChatComponent'
import {
  ChartWaterfallComponent,
  ChartWaterfallComponentLoading,
} from '@/catalog-apps/components/component-library/ChartWaterfall/ChartWaterfallComponent'
import {
  TriangleComponent,
  TriangleComponentLoading,
} from '@/catalog-apps/components/component-library/Triangle/TriangleComponent'
import {
  ListCardsComponent,
  ListCardsComponentLoading,
} from '@/catalog-apps/components/component-library/ListCards/ListCardsComponent'
import {
  WordCloudComponent,
  WordCloudComponentLoading,
} from '@/catalog-apps/components/component-library/WordCloud/WordCloudComponent'
import {
  ChartDivergingBarComponent,
  ChartDivergingBarComponentLoading,
} from '@/catalog-apps/components/component-library/ChartDivergingBar/ChartDivergingBarComponent'
import {
  BankReconComponent,
  BankReconComponentLoading,
} from '@/catalog-apps/components/component-library/BankRecon/BankReconComponent'
import {
  ScrollContainerComponent,
  ScrollContainerComponentLoading,
} from '@/catalog-apps/components/component-library/ScrollContainer/ScrollContainerComponent'
import {
  OrgChartComponent,
  OrgChartComponentLoading,
} from '@/catalog-apps/components/component-library/OrgChart/OrgChartComponent'
import {
  ChartIcicleComponent,
  ChartIcicleComponentLoading,
} from '@/catalog-apps/components/component-library/ChartIcicle/ChartIcicleComponent'
import {
  ButtonActionsComponent,
  ButtonActionsComponentLoading,
} from '@/catalog-apps/components/component-library/ButtonActions/ButtonActionsComponent'
import {
  FinancialStatementComponent,
  FinancialStatementComponentLoading,
} from '@/catalog-apps/components/component-library/FinancialStatement/FinancialStatementComponent'
const renderFallback = (type: TComponentType) => {
  switch (type) {
    case 'table':
      return <DataTableLoading />
    case 'form':
      return <FormComponentLoading />
    case 'vega-lite-chart':
      return <ChartLoading />
    case 'card':
      return <CardsComponentLoading />
    case 'chat':
      return <ChatComponentLoading />
    case 'live-chat':
      return <LiveChatComponentLoading />
    case 'quick-nav':
      return <QuickNavLoading />
    case 'data-form':
      return <DataFormComponentLoading />
    case 'md-text':
      return <MdTextComponentLoading />
    case 'chart-sankey':
      return <ChartSankeyComponentLoading />
    case 'tree-navigator':
      return <TreeNavigatorComponentLoading />
    case 'chart-radial':
      return <ChartRadialComponentLoading />
    case 'chart-bar':
      return <ChartBarComponentLoading />
    case 'chart-scatter':
      return <ChartScatterComponentLoading />
    case 'chart-heatmap':
      return <ChartHeatmapComponentLoading />
    case 'chart-pie':
      return <ChartPieComponentLoading />
    case 'chart-radar':
      return <ChartRadarComponentLoading />
    case 'stepper-component':
      return <StepperComponentLoading />
    case 'chart-dumbbell':
      return <ChartDumbbellComponentLoading />
    case 'data-table-v2':
      return <DataTableV2ComponentLoading />
    case 'statement-editor-v2':
      return <StatementEditorV2ComponentLoading />
    case 'chart-line':
      return <ChartLineComponentLoading />
    case 'file-manager':
      return <FileManagerComponentLoading />
    case 'agent-chat':
      return <AgentChatComponentLoading />
    case 'chart-waterfall':
      return <ChartWaterfallComponentLoading />
    case 'triangle':
      return <TriangleComponentLoading />
    case 'list-cards':
      return <ListCardsComponentLoading />
    case 'word-cloud':
      return <WordCloudComponentLoading />
    case 'chart-diverging-bar':
      return <ChartDivergingBarComponentLoading />
    case 'bank-recon':
      return <BankReconComponentLoading />
    case 'scroll-container':
      return <ScrollContainerComponentLoading />
    case 'org-chart':
      return <OrgChartComponentLoading />
    case 'chart-icicle':
      return <ChartIcicleComponentLoading />
    case 'button-actions':
      return <ButtonActionsComponentLoading />
    case 'financial-statement':
      return <FinancialStatementComponentLoading />





    default:
      return <div>Loading...</div>
  }
}

// export function ComponentRenderer({
//   type,
//   id,
//   containerId,
//   tileContainerRef,
// }: TComponentConfig & { containerId: string; tileContainerRef: React.RefObject<HTMLDivElement> }) {
export function ComponentRenderer({
  component,
  containerId,
  tileContainerRef,
  sizing = 'viewport',
}: {
  component: TComponentConfig
  containerId: string
  tileContainerRef: React.RefObject<HTMLDivElement>
  sizing?: ComponentSizing
}) {
  const { isConfiguringLayout } = useAppPageState()
  const isPageBuilder = useIsPageBuilder()
  const queryClient = useQueryClient()
  const { appKey, projectId, organisationId, page, pageId } = useAppContext()
  const { isSelectingContext, addOrUpdateSelection, removeSelection, hasSelection } = useAiChatComponentContext()
  const componentId = component?.id ?? '__missing-component-id__'
  const componentType = component?.type ?? 'component-type'
  const matchingFetchCount = useIsFetching({
    queryKey: [componentId, componentType],
  })
  if (!component) return null
  const { type, id } = component
  const selectionKey = getAiChatComponentSelectionKey({
    pageId,
    componentType: type,
    componentId: id,
  })
  const latestSnapshot = findLatestComponentContextSnapshot({
    queryClient,
    componentId: id,
    componentType: type,
    appKey,
    projectId,
  })
  const isChecked = hasSelection(selectionKey)
  const isSelectable = isComponentTypeContextSelectable(type)
  const canSelect = isSelectable && Boolean(latestSnapshot)

  const handleToggleSelection = () => {
    if (!isSelectingContext) return
    if (isChecked) {
      removeSelection(selectionKey)
      return
    }
    if (!latestSnapshot) return

    addOrUpdateSelection({
      componentId: id,
      componentType: type,
      containerId,
      appKey,
      projectId,
      organisationId,
      page,
      pageId,
      queryKey: latestSnapshot.queryKey,
      filters: latestSnapshot.filters,
      response: latestSnapshot.response,
      dataUpdatedAt: latestSnapshot.dataUpdatedAt,
    })
  }

  const renderComponent = () => {
    switch (type) {
      case 'table':
        return <DataTableComponent id={id} />
      case 'form':
        return <FormComponent id={id} />
      case 'vega-lite-chart':
        return <ChartComponent id={id} tileContainerRef={tileContainerRef!} />
      case 'card':
        return <CardsComponent id={id} />
      case 'statement-editor':
        return <StatementEditorComponent id={id} />
      case 'chat':
        return <ChatComponent id={id} />
      case 'live-chat':
        return <LiveChatComponent id={id} />
      case 'quick-nav':
        return <QuickNavComponent />
      case 'data-form':
        return <DataFormComponent id={id} />
      case 'tab-container':
        return <TabContainerComponent id={id} />
      case 'md-text':
        return <MdTextComponent id={id} />
      case 'chart-sankey':
        return <ChartSankeyComponent id={id} />
      case 'tree-navigator':
        return <TreeNavigatorComponent id={id} tileContainerRef={tileContainerRef} />
      case 'chart-radial':
        return <ChartRadialComponent id={id} />
      case 'chart-bar':
        return <ChartBarComponent id={id} />
      case 'chart-scatter':
        return <ChartScatterComponent id={id} />
      case 'chart-heatmap':
        return <ChartHeatmapComponent id={id} />
      case 'chart-pie':
        return <ChartPieComponent id={id} />
      case 'chart-radar':
        return <ChartRadarComponent id={id} />
      case 'stepper-component':
        return <StepperComponent id={id} />
      case 'chart-dumbbell':
        return <ChartDumbbellComponent id={id} />
      case 'data-table-v2':
        return <DataTableV2Component id={id} />
      case 'statement-editor-v2':
        return <StatementEditorV2Component id={id} />
      case 'chart-line':
        return <ChartLineComponent id={id} />
      case 'file-manager':
        return <FileManagerComponent id={id} />
      case 'agent-chat':
        return <AgentChatComponent id={id} />
      case 'chart-waterfall':
        return <ChartWaterfallComponent id={id} />
      case 'triangle':
        return <TriangleComponent id={id} />
      case 'list-cards':
        return <ListCardsComponent id={id} />
      case 'word-cloud':
        return <WordCloudComponent id={id} />
      case 'chart-diverging-bar':
        return <ChartDivergingBarComponent id={id} />
      case 'bank-recon':
        return <BankReconComponent id={id} />
      case 'scroll-container':
        return <ScrollContainerComponent id={id} />
      case 'org-chart':
        return <OrgChartComponent id={id} />
      case 'chart-icicle':
        return <ChartIcicleComponent id={id} />
      case 'button-actions':
        return <ButtonActionsComponent id={id} />
      case 'financial-statement':
        return <FinancialStatementComponent id={id} />





      default:
        return (
          <div className="flex flex-col gap-y-2">
            {!isPageBuilder && (
              <>
                <span>Type: {type}</span>
                <span>Id: {id}</span>
              </>
            )}
          </div>
        )
    }
  }

  return (
    <ComponentWrapper
      fallback={renderFallback(type)}
      id={id}
      sizing={sizing}
      preserveHeight={type === 'scroll-container'}
      contextSelectionOverlay={
        isSelectingContext ? (
          <button
            type="button"
            // className="absolute right-3 top-3 z-20 inline-flex items-center gap-2 rounded-md border bg-background/95 px-2 py-1 text-xs shadow-sm"
            className="absolute right-3 top-3 z-20 inline-flex items-center gap-2 rounded-md bg-secondary px-2 py-1 text-xs shadow-sm"
            onClick={handleToggleSelection}
            disabled={!canSelect}
            title={
              !isSelectable
                ? 'This component type is not supported in context capture yet'
                : !latestSnapshot
                  ? matchingFetchCount > 0
                    ? 'Loading latest data...'
                    : 'No response data available yet'
                  : 'Add or remove this component context'
            }
          >
            <Checkbox
              className="bg-background"
              checked={isChecked}
              disabled={!canSelect}
              aria-label={`Select ${type} context for ${id}`}
            />
            <span>{isChecked ? 'Added' : 'Add to chat context'}</span>
          </button>
        ) : null
      }
    >
      {renderComponent()}
      {isPageBuilder && !isConfiguringLayout && (
        <div className="absolute -top-0.5 right-1/2 translate-x-1/2">
          <BuilderComponentSelector containerId={containerId} type={type} />
        </div>
      )}
    </ComponentWrapper>
  )
}

function StandardContainer({
  children,
  sizing,
  preserveHeight,
}: {
  children: React.ReactNode
  sizing: ComponentSizing
  preserveHeight: boolean
}) {
  const { isConfiguringLayout } = useAppPageState()
  const hasViewportHeight = sizing === 'viewport' || preserveHeight
  return (
    <motion.div
      {...PRESENCE_ANIMATION}
      className={clsx(
        'relative w-full p-5',
        hasViewportHeight ? 'h-full' : 'h-auto',
        sizing === 'viewport' ? 'overflow-hidden' : 'overflow-visible',
        sizing === 'content' && 'pr-0',
        isConfiguringLayout && 'pointer-events-none opacity-50'
      )}
    >
      {children}
    </motion.div>
  )
}

function ComponentWrapper({
  children,
  fallback,
  id,
  sizing,
  preserveHeight,
  contextSelectionOverlay,
}: {
  children: React.ReactNode
  fallback: React.ReactNode
  id: string
  sizing: ComponentSizing
  preserveHeight: boolean
  contextSelectionOverlay?: React.ReactNode
}) {
  return (
    <AnimatePresence>
      <StandardContainer preserveHeight={preserveHeight} sizing={sizing}>
        {contextSelectionOverlay}
        <QueryErrorBoundary
          key={id}
          errorMessage={
            <span>
              Failed to fetch data for <span className="font-semibold italic">"{id}"</span>
            </span>
          }
        >
          <Suspense fallback={fallback}>
            <TileFiltersProvider>{children}</TileFiltersProvider>
          </Suspense>
        </QueryErrorBoundary>
      </StandardContainer>
    </AnimatePresence>
  )
}
